import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { UserPage } from './user';
import { PipesModule } from '../../pipes/pipes.module';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
  declarations: [
    UserPage,
  ],
  imports: [
		PipesModule,
    ComponentsModule,
    IonicPageModule.forChild(UserPage),
  ],
})
export class UserPageModule {}



// WEBPACK FOOTER //
// ./src/pages/user/user.module.ts